import React from 'react';
import InputFilter from './InputFilter';
import SelectFilter from './SelectFilter';

class FilterField extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = { value: '' };
  }

  render() {
    const {
      query,
      tableId,
      columnKey,
      currentColumn,
      handleKeyPress,
      applyFilters,
      filterable = false,
    } = this.props;
    const showFilter =
      currentColumn.type == 'filter' ||
      currentColumn.datatype == 'date' ||
      currentColumn.datatype == 'integer';
    const showInput = currentColumn.type != 'filter';

    return (
      <div className="filters d-flex flex-wrap gap-16">
        {currentColumn.filter_label}
        {showFilter && (
          <SelectFilter
            columnKey={columnKey}
            currentColumn={currentColumn}
            query={query}
            applyFilters={applyFilters}
            tableId={tableId}
            value={this.state.value}
            filterable={filterable}
          />
        )}
        {showInput && (
          <InputFilter
            columnKey={columnKey}
            currentColumn={currentColumn}
            query={query}
            applyFilters={applyFilters}
            handleKeyPress={handleKeyPress}
            tableId={tableId}
            value={this.state.value}
            setValue={value => this.setState({ value })}
          />
        )}
      </div>
    );
  }
}

export default FilterField;
